import { Table } from "antd";
import React, { useEffect } from "react";
import { PlanscolumnsV1 } from "./PlansColumnV1";


const AllPlansV1 = (props) => {
  const { group_name,data,setAmount } = props;

  useEffect(() => {
  }, [group_name,data]);
  return (
    <>
      <Table
        className="custom-table h-[320px] overflow-x-auto text-white rounded-none"
        columns={PlanscolumnsV1(setAmount)}
        pagination={false}
        dataSource={data}
      />
    </>
  );
};

export default AllPlansV1;